<template>
  <div :class="$style.findEvents">
    <div :class="[$style.findEventsMenu, activeTab ? $style.active : '']">
      <a :class="[activeTab === 'period' ? $style.selected : '']" @click.prevent="onClickMenu('period')">開催日</a>
      <a :class="[activeTab === 'genre' ? $style.selected : '']" @click.prevent="onClickMenu('genre')">ジャンル</a>
      <a :class="[activeTab === 'area' ? $style.selected : '']" @click.prevent="onClickMenu('area')">エリア</a>
    </div>
    <div :class="$style.findEventsContent">
      <ul v-if="activeTab === 'period'">
        <li>
          <a href="/events?period=ongoing">{{ periodLabel('ongoing') }}</a>
        </li>
        <li>
          <a href="/events?period=this-week">{{ periodLabel('this-week') }}</a>
        </li>
        <li>
          <a href="/events?period=this-weekend">{{ periodLabel('this-weekend') }}</a>
        </li>
        <li>
          <a href="/events?period=this-month">{{ periodLabel('this-month') }}</a>
        </li>
        <li>
          <a href="/events?period=next-month">{{ periodLabel('next-month') }}</a>
        </li>
      </ul>
      <ul v-if="activeTab === 'genre'">
        <li v-for="genre in genreList" :key="genre.slug">
          <a :href="`/events?genre=${genre.slug}`">{{ genre.name }}</a>
        </li>
      </ul>
      <div v-if="activeTab === 'area'" :class="$style.area">
        <section v-for="area in areaList" :key="area.slug">
          <p :class="[activeArea === area.slug ? $style.selected : '']" @click.prevent="onClickArea(area.slug)">
            {{ area.name }}
          </p>
          <div :class="$style.prefectures">
            <a v-for="p in area.prefectures" :key="p.slug" :href="`/events?prefecture=${p.slug}`">{{ p.name }}</a>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { areas as areaList } from '@/js/data/area';
import genreList from '@/js/data/genre';

const activeTab = ref<string>();
const activeArea = ref<string>();
const labelObj = {
  ongoing: '開催中',
  'this-week': '今週',
  'this-weekend': '今週末',
  'this-month': '今月',
  'next-month': '来月以降',
};
const periodLabel = (period: keyof typeof labelObj) => labelObj[period] || '';
const onClickMenu = (item: string) => {
  activeTab.value = activeTab.value === item ? undefined : item;
};
const onClickArea = (area: string) => {
  activeArea.value = activeArea.value === area ? undefined : area;
};
</script>

<style module lang="scss">
.findEvents {
  h3 {
    margin-top: 25px;
  }

  .findEventsMenu {
    display: grid;
    gap: 5px;
    grid-template-columns: repeat(3, 1fr);

    & + div {
      max-height: 0;
      overflow: hidden;
      padding: 0 10px;
      transition:
        max-height 0s ease-in-out,
        padding 0s ease-in-out;
    }

    &.active {
      & + div {
        border: 1px solid var(--border-color);
        max-height: 417px;
        padding: 5px 10px 10px;
        transition:
          max-height 0.15s ease-in-out,
          padding 0.1s ease-in-out;
      }

      a {
        border-bottom: 0;
        color: #8e8e8e;
      }
    }

    a {
      background-color: var(--color-white);
      border: 1px solid var(--border-color);
      color: #404040;
      display: inline-block;
      line-height: 34px;
      padding-left: 10px;
      position: relative;
      text-align: left;
      text-decoration: none;

      &.selected {
        border-bottom: 0;
        color: #404040;
        margin-bottom: -1px;

        &::after {
          transform: rotate(180deg);
          transition: transform 0.1s ease-in-out;
        }
      }

      &::after {
        color: #8e8e8e;
        content: $icon-arrow-bottom;
        font-family: $font-icon;
        font-size: 28px;
        line-height: 34px;
        position: absolute;
        right: 0;
      }
    }
  }

  .findEventsContent {
    background-color: var(--color-white);

    ul {
      display: grid;
      gap: 10px;
      grid-template-columns: repeat(3, 1fr);
      margin-top: 10px;
    }

    a {
      background-color: var(--color-gray180);
      color: #404040;
      display: block;
      font-size: 13px;
      line-height: 36px;
      text-align: center;

      @media (--sp-mini) {
        font-size: 12px;
      }
    }

    .area {
      > section p {
        background-color: var(--color-white);
        color: #404040;
        cursor: pointer;
        display: block;
        font-weight: normal;
        line-height: 28px;
        margin-top: 5px;

        &::before {
          content: '＋';
          display: inline-block;
          text-align: center;
          width: 20px;
        }

        &.selected {
          font-weight: bold;

          &::before {
            content: '−';
          }

          & + .prefectures {
            margin-top: 10px;
            max-height: 200px;
          }
        }
      }

      .prefectures {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(4, 1fr);
        margin-top: 0;
        max-height: 0;
        overflow: hidden;

        a {
          background-color: var(--color-gray180);
          color: #404040;
          line-height: 36px;
          text-align: center;
        }
      }
    }
  }
}
</style>
